export const TranslationsEL = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Online Παραγγελία",
        cart: "Καλάθι",
        open_24: "24 Ώρες",
        closed: "Κλειστά",
        free: "Δωρεάν",
        something_went_wrong: "Ούπς, κάτι πήγε στραβά",
        try_again: "Δοκιμάστε ξανά",
    },
    constants: {
        calendar: {
            days: {
                monday: "Δευτέρα",
                tuesday: "Τρίτη",
                wednesday: "Τετάρτη",
                thursday: "Πέμπτη",
                friday: "Παρασκευή",
                saturday: "Σάββατο",
                sunday: "Κυριακή",
            },
        },
        services: {
            pickup: "Παραλαβή",
            delivery: "Delivery",
            dine_in: "Δείπνο",
            table_booking: "Κράτηση Τραπεζιού",
        },
        payment: {
            method: {
                cash: "Μετρητά",
                card: "Κάρτα",
                stripe: "Πιστωτική Κάρτα",
                paypal: "PayPal",
                cardconnect: "Πιστωτική Κάρτα",
                checkout: "Ολοκλήρωση παραγγελίας",
                checkout_apple_pay: "Apple Pay (Checkout.com)",
                checkout_google_pay: "Google Pay (Checkout.com)",
                razor_pay: "Razor Pay",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                ath_movil: "ATH Móvil",
                custom: "Custom",
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: "Μετρητά",
                card: "Κάρτα",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                bambora_na: "Worldline",
                pesapal: "Pesapal",
                ath_movil: "ATH Móvil",
                checkout: "Ολοκλήρωση παραγγελίας",
                checkout_apple_pay: "Apple Pay (Checkout.com)",
                checkout_google_pay: "Google Pay (Checkout.com)",
                stripe_digital_wallet: "Google/Apple Pay",
                razor_pay: "Razor Pay",
                gravity: "Gravity",
                authorized: "Authorize.net",
                elavon: "Elavon",
                red_dot: "Red Dot Payment",
                custom: "Custom",
            },
            status: {
                success: "Επιτυχής Συναλλαγή",
                pending: "Εκκρεμής Συναλλαγή",
                error: "Σφάλμα",
                refunded: "Επιστροφή χρημάτων",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Αφαιρώ",
                drop_here: "Αποθέστε τα αρχεία σας εδώ ή κάντε κλικ για να επιλέξετε ένα",
                accepts: "Αποδεκτά {{fileTypes}} αρχεία",
                errors: {
                    max_files: "Αποδεκτός αριθμός αρχείων{{number}} ",
                    max_size: "Αποδεκτό μέγεθος αρχείων {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Το κατάστημα είναι κλειστό αυτήν τη στιγμή και δεν είναι δυνατή η τοποθέτηση παραγγελίας για φαγητό. Μπορείτε να δοκιμάσετε παραγγελία για μεταγενέστερη ημερομηνία και ώρα",
            },
            buttons: {
                order: {
                    book_order: "Κράτηση Τραπεζιού/ Παραγγελία Online",
                    order_online: "Παραγγελία Online",
                    book_table: "Κράτηση Τραπεζιού",
                    order: "Παραγγελία",
                    book: "Κράτηση",
                    cart: "Καλάθι",
                    restart: "Επανεκκίνηση",
                    closed: "Το κατάστημα είναι κλειστό",
                    not_accepting: "Δεν δεχόμαστε παραγγελίες",
                },
            },
        },
        modals: {
            auth: {
                login: "Σύνδεση",
                register: "Εγγραφή",
                register_commence: "Επόμενο",
                register_complete: "Δημιουργία λογαριασμού",
                register_confirmation_sent: "Ένας κωδικός επιβεβαίωσης έχει σταλεί στη διεύθυνση ηλεκτρονικού ταχυδρομείου σας. Εισαγάγετε τον παρακάτω για να συνεχίσετε",
                register_confirmation_resent: "Ο κωδικός επιβεβαίωσης έχει σταλεί ξανά, ελέγξτε τα ανεπιθύμητα μηνύματα ή επανεκκινήστε τη διαδικασία",
                register_restart: "Επανεκκίνηση",
                register_resend_code: "Εκ νέου αποστολή κωδικού",
                login_placeholder: "E-mail",
                password_placeholder: "Κωδικός πρόσβασης",
                confirm_password_placeholder: "Επιβεβαίωση Κωδικού",
                confirmation_code_placeholder: "Κωδικός επιβεβαίωσης E-Mail ",
                accept_terms: "Αποδοχή Όρων και Προϋποθέσεων",
                accept_terms_view: "Προβολή",
                login_facebook: "Σύνδεση με  Facebook",
                login_google: "Σύνδεση με  Google",
                benefits: "Συνδεθείτε ή δημιουργήστε λογαριασμό για να αποθηκεύετε όλες τις παραγγελίες σας",
                logged_in: "Συνδεθήκατε με επιτυχία",
                logged_out: "Αποσύνδεση",
                password_reset: {
                    init_button: "Αποστολή επαναφοράς κωδικού πρόσβασης e-mail",
                    init_success: "Ο σύνδεσμος επαναφοράς κωδικού πρόσβασης έχει σταλεί στο e-mail",
                    complete_button: "Επαναφορά κωδικού πρόσβασης",
                    complete_success: "Ο κωδικός πρόσβασης επαναφέρθηκε με επιτυχία, συνδεθείτε με τον νέο σας κωδικό",
                    forgot_password_text: "Ξέχασες τον κωδικό σου; ",
                    forgot_password_link: "Επαναφορά κωδικού πρόσβασης",
                    remember_password_text: "Θυμάστε τον κωδικό πρόσβασής σας; ",
                    remember_password_link: "Πήγαινε πίσω",
                    invalid_title: "Αποτυχία επαναφοράς κωδικού πρόσβασης",
                    invalid_description: "Αυτός ο σύνδεσμος επαναφοράς κωδικού πρόσβασης δεν είναι έγκυρος, ζητήστε ένα νέο",
                    invalid_link: "Μετάβαση στη Σύνδεση",
                    title: "Επαναφορά Κωδικού",
                    description: "Εισαγάγετε έναν νέο κωδικό πρόσβασης για τον λογαριασμό σας",
                },
                error_generic: "Κάτι πήγε στραβά, δοκιμάστε ξανά ή επικοινωνήστε μαζί μας",
                error_accept_terms: "Παρακαλώ αποδεχτείτε τους όρους και τις προϋποθέσεις",
                error_password_length: "Τουλάχιστον 6 χαρακτήρες για κωδικό πρόσβασης",
                error_social: "Κάτι πήγε στραβά, δοκιμάστε ξανά ή επικοινωνήστε μαζί μας",
                error_confirmation_code: "Μη έγκυρος κωδικός επιβεβαίωσης",
                error_invalid_code: "Μη έγκυρος κωδικός επιβεβαίωσης",
                error_exists: "Ο χρήστης υπάρχει ήδη",
                error_invalid_email_pass: "Μη έγκυρη διεύθυνση e-mail ή κωδικός πρόσβασης",
                error_password_no_match: "Οι κωδικοί πρόσβασης δεν ταιριάζουν μεταξύ τους",
                error_user_not_found: "Δεν υπάρχει χρήστης με αυτό το e-mail",
                error_invalid_email: "Μη έγκυρη διεύθυνση e-mail",
                error_invalid_reset_token: "Μη έγκυρος σύνδεσμος επαναφοράς, ζητήστε άλλο",
            },
            booking: {
                form: {
                    name: "Πλήρες όνομα",
                    email: "E-Mail",
                    phone: "Τηλέφωνο",
                    number_of_people: "Αριθμός ανθρώπων",
                    number_of_people_max: "Μέγιστος αριθμός ανθρώπων ({{max_people}} Max)",
                    number_of_people_min: "Ελάχιστος αριθμός ανθρώπων ({{min_people}} Min)",
                    number_of_people_max_min: "Αριθμός ανθρώπων (από {{min_people}} εώς {{max_people}})",
                    notes: "Σημειώσεις / Ειδικά αιτήματα",
                    submit: "Υποβολή αιτήματος κράτησης",
                    email_optional: "(προαιρετικό)",
                    date: "Ημερομηνία",
                    duration: "Διάρκεια",
                    seating: "Διαθέσιμες ώρες",
                    number_of_guests: "Αριθμός ατόμων",
                    notes_placeholder: "Αλλεργίες, περίσταση, προτίμηση θέσης",
                    reserving: "Κράτηση...",
                    reserve_table: "Κράτηση τραπεζιού",
                    please_choose_a_date_and_time: "Επιλέξτε ημερομηνία και ώρα.",
                    invalid_people: "Ο αριθμός ατόμων πρέπει να είναι μεταξύ {{min}} και {{max}}.",
                    party_size_max_fallback: "το επιτρεπόμενο μέγιστο",
                    loading_available_times: "Φόρτωση διαθέσιμων ωρών…",
                    select_a_date_to_see_available_times: "Επιλέξτε ημερομηνία για να δείτε τις διαθέσιμες ώρες.",
                    no_times_available_for_this_date: "Δεν υπάρχουν διαθέσιμες ώρες για αυτή την ημερομηνία. Επιλέξτε άλλη ημέρα.",
                    shift: "Βάρδια",
                    service_times: "Ώρες εξυπηρέτησης",
                    new_shift: "Νέα βάρδια",
                    time: "ώρα",
                    times: "ώρες",
                    unavailable: "Μη διαθέσιμο",
                    available: "Διαθέσιμο",
                    required_name: "Εισαγάγετε το όνομά σας.",
                    required_phone: "Εισαγάγετε τον αριθμό τηλεφώνου σας.",
                    required_email: "Εισαγάγετε το email σας.",
                    invalid_email: "Εισαγάγετε έγκυρο email.",
                    required_terms: "Αποδεχτείτε τους όρους πριν την κράτηση.",
                    reservation_is_unavailable: "Η κράτηση δεν είναι διαθέσιμη.",
                    please_contact_the_restaurant_directly: "Επικοινωνήστε απευθείας με το εστιατόριο.",
                    almost_done: "Σχεδόν έτοιμο",
                    your_details: "Τα στοιχεία σας",
                    tell_us_who_s_coming: "Πείτε μας ποιος έρχεται για να επιβεβαιώσουμε την κράτησή σας.",
                    book_your_table: "Κλείστε το τραπέζι σας",
                    choose_a_time_that_works_for_you: "Επιλέξτε μια ώρα που σας εξυπηρετεί.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Στείλτε το αίτημα κράτησης και το εστιατόριο αναλαμβάνει τα υπόλοιπα.",
                    select_date: "Επιλογή ημερομηνίας",
                    standard: "Κανονική",
                    minutes: "λεπτά",
                    next: "Επόμενο →",
                    back: "← Πίσω",
                    accept_terms: "Αποδέχομαι τους όρους και τις προϋποθέσεις.",
                    info_1: "Θα λάβετε ειδοποίηση μέσω e-mail όταν η κράτησή σας γίνει αποδεκτή ή απορριφθεί",
                },
                errors: {
                    not_found: "Η κράτηση δεν υπάρχει. Διαγράφηκε πιθανώς",
                    generic: "Κάτι πήγε στραβά, ανανεώστε τη σελίδα ή επικοινωνήστε μαζί μας",
                    something_went_wrong: "Κάτι πήγε στραβά",
                    accept_terms: "Αποδεχτείτε τους όρους και τις προϋποθέσεις",
                    required_phone: "Εισαγάγετε τον αριθμό τηλεφώνου σας",
                    required_email: "Εισαγάγετε το e-mail σας",
                    required_zip: "Εισάγετε τον ταχυδρομικό κωδικό χρέωσης",
                    required_name: "Παρακαλώ εισάγετε το όνομά σας",
                    invalid_email: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση e-mail",
                    invalid_phone: "Παρακαλώ εισάγετε έναν έγκυρο αριθμό τηλεφώνου",
                    invalid_people: "Μη έγκυρος αριθμός ατόμων",
                    missing_custom_fields: "Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία",
                    booking_capacity_threshold: "Είμαστε πλήρεις για αυτή την ώρα. Δοκιμάστε άλλη ώρα.",
                    slot_unavailable: "Είμαστε πλήρεις για αυτόν τον αριθμό ατόμων. Δοκιμάστε άλλη ώρα.",
                    booking_date_paused: "Οι κρατήσεις έχουν διακοπεί για αυτή την ημερομηνία. Επιλέξτε άλλη ημέρα.",
                    invalid_table_assignment: "Αυτά τα τραπέζια δεν χωρούν την παρέα σας. Επιλέξτε άλλη ώρα.",
                    exceeded_order_limit: "Πάρα πολλά αιτήματα κράτησης. Δοκιμάστε ξανά αργότερα.",
                    validation_failed_recaptcha_v3: "Εντοπίστηκε ασυνήθιστη κίνηση. Χρησιμοποιείτε VPN; Ολοκληρώστε την επαλήθευση παραπάνω και δοκιμάστε ξανά.",
                    validation_failed_recaptcha_v2: "Η κράτηση δεν μπόρεσε να ξεκινήσει. Δοκιμάστε ξανά ή χρησιμοποιήστε άλλον τρόπο. Αν χρησιμοποιείτε VPN, απενεργοποιήστε το πρώτα.",
                    booking_already_exists: "Αυτή η κράτηση έχει ήδη σταλεί. Ελέγξτε το email σας ή ανοίξτε τον σύνδεσμο κράτησης.",
                    invalid_party_size: "Επιλέξτε έγκυρο αριθμό ατόμων.",
                    invalid_request: "Μη έγκυρο αίτημα. Ανανεώστε τη σελίδα και δοκιμάστε ξανά.",
                    table_booking_unavailable: "Η κράτηση τραπεζιού δεν είναι διαθέσιμη.",
                },
            },
            cart: {
                title: "Καλάθι",
                proceed_to_checkout: "Ολοκλήρωση παραγγελίας",
                edit_dish: "Επεξεργασία",
                remove_dish: "Αφαιρώ",
                no_items_1: "Δεν υπάρχουν είδη στο καλάθι",
                no_items_2: "Προσθέστε μερικά είδη για συνέχιση",
                free_delivery_notice: "Δωρεάν παράδοση για παραγγελίες άνω των {{value, currency}}",
                errors: {
                    min_order_promo: "Ελάχιστο ποσό που απαιτείται πριν από την εφαρμογή της προσφοράς {{value, currency}}",
                    min_order_delivery: "Ελάχιστο ποσό που απαιτείται για delivery {{value, currency}}",
                },
                promo: {
                    heading: "Κωδικός προσφοράς",
                    placeholder: "Εισήγαγε τον κωδικό προσφοράς",
                    add: "Προσθήκη κωδικού",
                    title: "Προσφορά {{name}} προστέθηκε στο καλάθι",
                    fixed_discount: "{{value, currency}} Έκπτωση",
                    percent_discount: "{{value}}% Έκπτωση",
                    added_to_cart: " Η προσφορά προστέθηκε στο καλάθι",
                    errors: {
                        not_found: "Η προσφορά δεν βρέθηκε",
                        disabled: "Η προσφορά είναι απενεργοποιημένη",
                        not_available: "Η προσφορά δεν είναι προς το παρόν διαθέσιμη",
                        logged_in_only: "Πρέπει να συνδεθείτε για να χρησιμοποιήσετε αυτήν την προσφοράo",
                        already_used: "Έχετε ήδη χρησιμοποιήσει αυτήν την προσφορά",
                        invalid: "Αυτή η προσφορά δεν είναι πλέον έγκυρη",
                        invalid_service: "Αυτή η προσφορά δεν ισχύει για την υπηρεσία που έχετε επιλέξει",
                        later_only: "Ισχύει μόνο για προπαραγγελίες",
                        now_only: "Ισχύει μόνο για παραγγελίες που γίνονται άμεσα και όχι για προπαραγγελίες",
                        generic: "Ωχ ... κάτι πήγε στραβά και καταγράφηκε",
                        dishes_required_multi: "Αυτή η προσφορά θα εφαρμοστεί μόνο όταν προστεθούν ορισμένα πιάτα στο καλάθι σας",
                        dishes_required_single: "Αυτή η προσφορά ισχύει μόνο για'{{dish}}'",
                    },
                },
                tip: {
                    title: "Φιλοδώρημα",
                    placeholder: "Προσθέστε φιλοδώρημα",
                },
            },
            checkout: {
                title: "Ολοκλήρωση παραγγελίας",
                subtitle: "Επιβεβαιώστε τα στοιχεία της παραγγελίας σας",
                details: {
                    service: "Υπηρεσία",
                    due: "Προγραμματισμός",
                    due_now_asap: "Τώρα / Το συντομότερον δυνατόν",
                    address: "Διεύθυνση παράδοσης",
                    total: "Σύνολο",
                    table: "Τραπέζι",
                    store_location: "Διεύθυνση καταστήματος",
                },
                customer: {
                    title: "Πελάτης",
                    subtitle: "Συνδεθείτε για να αποθηκεύσετε την παραγγελία και τα στοιχεία σας",
                    button: "Σύνδεση",
                    name: "Πλήρες όνομα",
                    email: "Διεύθυνση E-Mail",
                    phone: "Τηλέφωνο ",
                    phone_important: "Τηλέφωνο (Υποχρεωτικό)",
                    notes: "Σημειώσεις παραγγελίας",
                    delivery_notes: "Οδηγίες παράδοσης / Σημειώσεις παραγγελίας",
                    no_contact_delivery_title: "Ζητήστε ανέπαφη παράδοση",
                    no_contact_delivery_description: "Ο οδηγός θα τοποθετήσει το φαγητό σας σε ασφαλή τοποθεσία και θα σας ειδοποιήσει κατά την άφιξη",
                },
                payment: {
                    title: "Μέθοδος πληρωμής",
                },
                accept_terms: "Αποδοχή Όρων &amp; Προϋποθέσεωνs",
                accept_terms_view: "Προβολή",
                processing_order: "Επεξεργασία παραγγελίας",
                warning: {
                    different_payment_currency: "Οι τιμές καταστήματος είναι σε {{store_currency}} αλλά ο τρόπος πληρωμής είναι σε {{payment_currency}}",
                    closing_soon: "Κλείνουμε σύντομα, οι παραγγελίες πρέπει να υποβληθούν εντός {{value}} λεπτών",
                    closed: "Λυπούμαστε, αυτή η υπηρεσία έχει κλείσει και οι παραγγελίες δεν γίνονται δεκτές",
                    expired: "Δεν μπορούμε πλέον να εκτελέσουμε την παραγγελία σας την επιλεγμένη ώρα. Επιλέξτε μεταγενέστερη ημερομηνία ή ώρα",
                },
                errors: {
                    stripe_generic: "Σφάλμα πιστωτικής κάρτας, δοκιμάστε ξανά ή δοκιμάστε άλλη μέθοδο",
                    stripe_loading_fail: "Σφάλμα κατά τη φόρτωση της φόρμας πληρωμής, δοκιμάστε ξανά",
                    something_went_wrong: "Κάτι πήγε στραβά",
                    paypal_generic: "Κάτι πήγε στραβά με το PayPal, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_fail: "Η πληρωμή απέτυχε, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_cancelled: "Η πληρωμή ακυρώθηκε, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_error: "Σφάλμα κατά την επεξεργασία της ηλεκτρονικής πληρωμής, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_declined: "Η μέθοδος πληρωμής σας απορρίφθηκε",
                    card_declined: "Η κάρτα σας απορρίφθηκε και δεν ήταν δυνατή η επεξεργασία της πληρωμής",
                    promo_max_uses_exceeded: "Αυτός ο κωδικός προσφοράς έχει φτάσει το όριο χρήσης του και δεν είναι πλέον διαθέσιμος.",
                    store_closed: "Το κατάστημα είναι κλειστό και δεν δέχεται πλέον παραγγελίες",
                    accept_terms: "Αποδεχτείτε τους όρους και τις προϋποθέσεις",
                    required_payment: "Επιλέξτε μέθοδο πληρωμήςd",
                    required_phone: "Εισάγετε τον αριθμό τηλεφώνου σας",
                    required_email: "Εισαγάγετε το e-mail σας",
                    required_zip: "Εισαγάγετε τον ταχυδρομικό κωδικό χρέωσης",
                    required_name: "Παρακαλώ εισάγετε το όνομά σας",
                    invalid_email: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση e-mail",
                    invalid_phone: "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνουr",
                    invalid_cc_number: "Ο αριθμός της πιστωτικής σας κάρτας δεν είναι έγκυρος",
                    retry_cc_number: "Κάτι πήγε στραβά, εισαγάγετε ξανά τον αριθμό της πιστωτικής σας κάρτας και δοκιμάστε ξανά",
                    closed: "Το κατάστημα είναι κλειστό και δεν δέχεται παραγγελίες",
                    promo_login_required: "Πρέπει να συνδεθείτε για να χρησιμοποιήσετε αυτήν την προσφορά",
                    promo_used: "Έχετε ήδη χρησιμοποιήσει αυτήν την προσφορά",
                    missing_custom_checkout_fields: "Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία",
                    delivery_unavailable: "Η υπηρεσία παράδοσης ενδέχεται να μην είναι διαθέσιμη αυτήν τη στιγμή. Εξετάστε το ενδεχόμενο να κάνετε μια παραγγελία παραλαβής από το κατάστημα",
                },
                button: {
                    continue: "Προς πληρωμή",
                    place_order: "Αποστολή παραγγελίας",
                },
                delivery_estimation: {
                    title: "Εκτίμηση παράδοσης",
                    details: {
                        provider: "Πάροχος παράδοσης",
                        estimated_fee: "Εκτιμώμενη χρέωση",
                        estimated_delivery_time: "Εκτιμώμενος χρόνος παράδοσης",
                    }
                }
            },
            customer: {
                age_v: {
                    title: "Επαλήθευση ηλικίας",
                    required_for_items: "Απαιτείται για παραγγελία συγκεκριμένου είδους",
                    min_age: "Ελάχιστη ηλικία: {{age}} χρονών",
                    est_time: "Εκτιμώμενος χρόνος επαλήθευσης: {{time}} ώρες",
                    upload_description: "Ανεβάστε το αναγνωριστικό σας παρακάτω για επαλήθευση. Μόλις επαληθευτεί, θα ειδοποιηθείτε μέσω e-mail. Ανεβάστε έως 2 εικόνες με μέγιστο μέγεθος 2 MB η καθεμία",
                    pending_description_1: "Σας ευχαριστούμε που υποβάλατε τα έγγραφά σας. Θα λάβετε ειδοποίηση μέσω e-mail όταν εγκριθείτε",
                    pending_description_2: "Ανανεώστε τη σελίδα για να ενημερώσετε την κατάσταση επαλήθευσής σας. Ο εκτιμώμενος χρόνος επαλήθευσης είναι {{time}} ώρες",
                    approved_description: "Ο λογαριασμός σας έχει επαληθευτεί και μπορείτε να παραγγείλετε από τα περιορισμένα μενού",
                    rejected_description: "Το αναγνωριστικό σας απορρίφθηκε. Εάν θέλετε να δοκιμάσετε ξανά, ανεβάστε ξανά το αναγνωριστικό σας",
                    upload: "Μεταφόρτωση",
                    reupload: "Επαναφόρτωση εγγράφων",
                    go_back: "Πηγαίνετε πίσω",
                    view_document: "Προβολή εγγράφου {{number}}",
                    status: {
                        unverified: "Μη επαληθευμένος",
                        pending: "Αναμονή για έγκριση",
                        approved: "Επιτυχής επαλήθευση",
                        rejected: "Απορρίφθηκε",
                    },
                },
                headings: {
                    sessions: "Συνεδρίες",
                    orders: "Παραγγελίες",
                    spend: "΄Εξοδα",
                    order_history: "Ιστορικό παραγγελιών",
                    loyalty_points: "Πόντοι πίστης",
                },
            },
            custom_payment: {
                title: "Φόρμα πληρωμής{{name}}",
                description: "Έχετε συμπληρώσει τη διαδικτυακή φόρμα πληρωμής. Συμπληρώστε τα παρακάτω πεδία για να πραγματοποιήσετε μια πληρωμή. Εάν δεν εισαχθεί κάποιο ποσό, τα στοιχεία σας θα αποθηκευτούν αλλά δεν θα χρεωθείτε",
                disabled: "Αυτή η σελίδα πληρωμής δεν έχει ρυθμιστεί σωστά. Επικοινωνήστε με τον κάτοχο του ιστότοπου για να διορθώσετε το πρόβλημα.",
                success: "Η πληρωμή σας υποβλήθηκε με επιτυχία και τα στοιχεία σας έχουν αποθηκευτεί. Ευχαριστώ",
                back: "Επιστροφή στην Αρχική",
                fields: {
                    name: "Πλήρες όνομα",
                    email: "E-mail",
                    reference: "Αναφορά πληρωμής",
                    amount: "Ποσό ($)",
                    name_on_card: "Ονομα στην κάρτα",
                    submit: "Υποβολή πληρωμής",
                },
                warning: {
                    currency: "Σημείωση: Ποσό πληρωμής σε {{actual}}, όχι σε {{default}}",
                },
                errors: {
                    generic: "Κάτι πήγε στραβά, δοκιμάστε ξανά ή επικοινωνήστε μαζί μας",
                    stripe_generic: "Σφάλμα πιστωτικής κάρτας, ανανεώστε τη σελίδα και δοκιμάστε ξανά",
                    payment_fail: "Η πληρωμή απέτυχε, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_cancelled: "Η πληρωμή ακυρώθηκε, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_error: "Σφάλμα κατά την επεξεργασία της ηλεκτρονικής πληρωμής, δοκιμάστε ξανά ή επιλέξτε έναν άλλο τρόπο πληρωμής",
                    payment_declined: "Η μέθοδος πληρωμής σας απορρίφθηκε",
                    card_declined: "Η κάρτα σας απορρίφθηκε και δεν ήταν δυνατή η επεξεργασία της πληρωμής",
                    promo_max_uses_exceeded: "Αυτός ο κωδικός προσφοράς έχει φτάσει το όριο χρήσης του και δεν είναι πλέον διαθέσιμος.",
                },
            },
            dish: {
                add: "Προσθήκη στο καλάθι",
                edit: "Ενημέρωση",
                notes: "Ειδικές Οδηγίες...",
                ingredients: {
                    title: "Συστατικά",
                    uncheck_remove: "Ξετσέκαρε για κατάργηση",
                },
                ingredients_title: "Συστατικά",
                combo: {
                    choose_dish: "Επιλέξτε ένα πιάτο",
                },
                option_sets: {
                    conditions: {
                        select_one: "Επιλέξτε ένα (Υποχρεωτικό)",
                        select_one_optional: "Επιλέξτε ένα (Προαιρετικό)",
                        select_between: "Επιλέξτε μεταξύ {{min}} - {{max}} (Υποχρεωτικό)",
                        select_at_least: "Επιλέξτε τουλάχιστον {{qty}} (Υποχρεωτικό)",
                        select_up_to: "Επιλέξτε έως {{qty}} (Προαιρετικό)",
                        select_multiple: "Επιλέξτε πολλαπλά (Προαιρετικό)",
                        free_amount: "Πρώτα {{qty}} Δωρεάν / {{selected}} έχουν επιλεγεί",
                    },
                },
                error: "Διορθώστε τυχόν επιλογές με κόκκινο χρώμα",
                added_to_cart: "Το είδος προστέθηκε στο καλάθι",
            },
            map: {
                zone_fee: "Κόστος παράδοσης",
                view_in_google: "Προβολή στους Χάρτες Google",
            },
            portal_go_back: {
                title: "Επιστροφή στην αναζήτηση καταστήματος?",
                description: "Τα είδη στο καλάθι σας θα χαθούν",
                cancel: "Ακύρωση",
                proceed: "Πίσω",
            },
            order: {
                config: {
                    services: {
                        title: "Επιλέξτε μια υπηρεσία",
                        table_booking: "Κράτηση τραπεζιού",
                    },
                    address_custom: {
                        input_placeholder: "Εισάγετε τη διεύθυνσή σας",
                    },
                    address: {
                        input_placeholder: "Βρείτε τη διεύθυνση παράδοσης",
                        extras_placeholder: "Προαιρετικά: Αριθμός, όνομα κτιρίου κ.τ.λ.",
                        search_placeholder: "Αναζητήστε τη διεύθυνσή σας",
                        not_found: "Η διεύθυνση δεν βρέθηκε, δοκιμάστε ξανά",
                        not_delivering: "Αυτήν τη στιγμή δεν παραδίδουμε σε αυτήν τη διεύθυνση",
                        not_in_range: "Η διεύθυνσή σας δεν βρίσκεται στην περιοχή που εξυπηρετούμε",
                        not_in_zone: "Η διεύθυνσή σας δεν βρίσκεται σε ενεργή ζώνη παράδοσης",
                        no_number: "Η διεύθυνσή σας πρέπει να έχει έναν αριθμό οδού",
                    },
                    datetime: {
                        title: "Πότε θα θέλατε την παραγγελία σας",
                        due_now: "Τώρα",
                        due_later: "Αργότερα",
                        service_not_available: "Δυστυχώς, προς το παρόν δεν αποδεχόμαστε παραγγελίες για {{service}}",
                        currently_closed: "Η υπηρεσία {{service}} αυτήν τη στιγμή δεν λειτουργεί, αλλά μπορείτε να παραγγείλετε αργότερα",
                        due_unavailable: "Μη διαθέσιμο",
                        due_closed: "Κλειστά",
                        select_date: "Επιλέξτε Ημερομηνία",
                        select_time: "Επιλέξτε Ώρα",
                        select_order_date: "Επιλέξτε ημερομηνία για την παραγγελία σας",
                        select_order_time: "Επιλέξτε ώρα για την παραγγελία σας",
                        select_booking_date: "Επιλέξτε ημερομηνίαγια την κράτηση σας",
                        select_booking_time: "Επιλέξτε ώρα για την κράτηση σας",
                        no_times_available: "Δεν υπάρχει διαθέσιμη ώρα για να διαλέξετε",
                        date_today: "(Σήμερα)",
                        date_closed: "(Κλειστά)",
                        date_bookings_paused: "(Κρατήσεις σε παύση)",
                        time_slot_closed: "Κλειστά",
                    },
                    number_of_people: {
                        placeholder: "Αριθμός ανθρώπων",
                    },
                    table: {
                        select: "Επιλέξτε Τραπέζι",
                        select_popup_title: "Επιλέξτε Τραπέζι",
                        password: "Κωδικός Τραπεζιού",
                        password_warning: "Εισάγετε τον κωδικό του τραπεζιού σας για να συνεχίσετε",
                    },
                    warning: {
                        closed: "Λυπούμαστε, προς το παρόν κλείσαμε / δεν αποδεχόμαστε παραγγελίες",
                        not_available: "Δυστυχώς, προς το παρόν δεν αποδεχόμαστε παραγγελίες",
                    },
                    eta: {
                        delivery: "Ο εκτιμώμενος χρόνος παράδοσης είναι περίπου {{minutesToCustomer}} λεπτά",
                        pickup: "Η παραγγελία θα είναι έτοιμη σε περίπου {{minutesToCustomer}} λεπτά",
                    },
                    start_button: "Έναρξη παραγγελίας",
                },
                history: {
                    invalid: "Δεν πληροί τις προϋποθέσεις για επαναπαραγγελία καθώς ορισμένα από τα αντικείμενα που παραγγέλθηκαν έχουν τροποποιηθεί ή δεν είναι πλέον διαθέσιμα",
                },
                reorder: {
                    title: "Γρήγορη επαναπαραγγελία",
                    description: "Παραγγείλετε εύκολα τα είδη από τις προηγούμενες παραγγελίες σας",
                },
            },
            receipt: {
                errors: {
                    not_found: "Η παραγγελία δεν βρέθηκε, ανανεώστε τη σελίδα και δοκιμάστε ξανά",
                    booking_not_found: "Η κράτηση δεν υπάρχει. Ίσως διαγράφηκε",
                    generic: "Κάτι πήγε στραβά, ανανεώστε τη σελίδα ή επικοινωνήστε μαζί μας",
                },
                connection: {
                    connected: "Ενημερώσεις σε πραγματικό χρόνο",
                    connecting: "Σύνδεση ενημερώσεων σε πραγματικό χρόνο",
                    disconnected: "Οι ενημερώσεις σε πραγματικό χρόνο αποσυνδέθηκαν",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Προειδοποίηση",
                    title: "Αποσύνδεση",
                    body: "Η αποσύνδεση θα καταργήσει τυχόν είδη που έχουν προστεθεί στο καλάθι σας",
                    cancel: "Ακύρωση",
                    proceed: "Σε εξέλιξη",
                },
                order_restart: {
                    warning: "Προειδοποίηση",
                    title: "Αλλαγή λεπτομερειών παραγγελίας",
                    body: "Αν αλλάξετε τα στοιχεία της παραγγελίας σας, θα καταργηθούν τα είδη στο καλάθι σας, καθώς ορισμένα πιάτα ενδέχεται να μην είναι διαθέσιμα",
                    cancel: "Ακύρωση",
                    proceed: "Σε εξέλιξη",
                },
                order_expired: {
                    subtitle: "Σημαντικό",
                    title: "Η παραγγελία άλλαξε αμέσως",
                    description: "Ο χρόνος που επιλέξατε για την παραγγελία σας δεν είναι πολύ μακριά. Ως εκ τούτου, η παραγγελία σας τροποποιήθηκε σε άμεση / Το συντομότερον δυνατόν",
                    button: "Εντάξει",
                },
                order_expiring: {
                    subtitle: "Σημαντικό",
                    title: "Η προθεσμία της παραγγελίας λήγει σύντομα",
                    description: "Η παραγγελία σας πρέπει να γίνει πριν {{time, timeFromTimestamp}} Διαφορετικά δεν θα ισχύει πλέον",
                    button: "Εντάξει",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Επισκέπτης",
                login: "Σύνδεση",
                login_signup: "Σύνδεση / Εγγραφή",
                logout: "Αποσύνδεση",
            },
            menus: {
                info: {
                    no_menus: "Προς το παρόν δεν υπάρχουν διαθέσιμα Μενού",
                    restrictions: "Περιορισμοί Μενού",
                    not_available: "Το Μενού δεν είναι διαθέσιμο",
                    unavailable: {
                        times: "Το Μενού δεν είναι διαθέσιμο, οι απαιτήσεις παραγγελίας σας δεν ταιριάζουν παρακάτω",
                        services: "Το Μενού δεν είναι διαθέσιμο, οι απαιτήσεις παραγγελίας σας δεν ταιριάζουν παρακάτω",
                        hours: "Το Μενού δεν είναι διαθέσιμο, οι ώρες παραγγελίας σας δεν βρίσκονται εντός των διαθέσιμων μενού",
                        pre_order: "Το Μενού δεν είναι διαθέσιμο, η παραγγελία σας δεν ταιριάζει με τις απαιτήσεις προπαραγγελίας",
                        age: "Το Μενού δεν είναι διαθέσιμο, πρέπει να είστε συνδεδεμένοι με έναν λογαριασμό επαληθευμένο για ηλικία για να παραγγείλετε από αυτό το μενού",
                    },
                    services: {
                        title: "Απαιτήσεις παραγγελίας",
                        pickup: "Παραλαβές",
                        delivery: "Deliveries",
                        dine_in: "Δείπνα",
                    },
                    times: {
                        now: "Όχι προπαραγγελίες",
                        later: "Μόνο προπαραγγελίες",
                    },
                    hours: {
                        title: "Διαθέσιμες ώρες",
                    },
                    preorder: {
                        title: "Απαιτήσεις προπαραγγελίας",
                        days_in_advance: "Πρέπει να παραγγείλετε {{days}} ημέρες νωρίτερα",
                        cutoff_time: "Τελευταία ώρα διακοπής παραγγελιών {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Περιορισμένη ηλικία",
                        approved: "Ο λογαριασμός σας έχει επαληθευτεί και μπορείτε να παραγγείλετε από αυτό το μενού",
                        rejected: "Απαιτείται επαλήθευση ηλικίας για παραγγελία. Δημιουργήστε έναν λογαριασμό και ανεβάστε το αναγνωριστικό σας",
                    },
                },
                search: {
                    title: 'Εξερεύνηση Μενού',
                    no_result: 'Δεν βρέθηκε τίποτα. Δοκιμάστε έναν άλλο όρο αναζήτησης',
                    placeholder: 'Τι ψάχνεις;'
                }
            },
            category: {
                restrictions: "Περιορισμοί κατηγορίας",
                not_available: "Μη διαθέσιμη κατηγορία",
                unavailable: {
                    services: "Η κατηγορία δεν είναι διαθέσιμη, οι απαιτήσεις παραγγελίας σας δεν ταιριάζουν παρακάτω",
                    hours: "Η κατηγορία δεν είναι διαθέσιμη, οι ώρες παραγγελίας σας δεν είναι εντός των διαθέσιμων ωρών αυτής της κατηγορίας",
                },
            },
            info: {
                location: {
                    title: "Τοποθεσία",
                    view_map: "Δες τον χάρτη",
                    phone: "Τηλέφωνο",
                },
                hours: {
                    title: "Ωρες λειτουργίας",
                    title_special: "Ειδικές ώρες λειτουργίας",
                },
                services: {
                    title: "Υπηρεσίες",
                    notes: "Σημειώσεις",
                    delivery: {
                        ranges: "Εύρος παράδοσης",
                        zones: "Ζώνες παράδοσης",
                        view_zones: "Προβολή ζωνών στο χάρτη",
                        fee: "Κόστος παράδοσης",
                        fee_short: 'Χρέωση',
                        fee_varies: "Διαφορές, εμφανίζονται στο καλάθι",
                        min_order: "Ελάχιστη παραγγελία",
                        min_order_short: 'Ελάχ. παραγ.',
                        no_min_order: "Χωρίς ελάχιστη παραγγελία",
                        free_amount: "Ποσό Δωρεάν παράδοσης",
                    },
                },
            },
            contact: {
                title: "Επικοινωνήστε μαζί μας",
                name: "Ονομα",
                email: "E-mail",
                phone: "Τηλέφωνο",
                message: "Εισάγετε το μήνυμά σας ...",
                send: "Αποστολή Μηνύματος",
                success: "Το μήνυμά σας έχει σταλεί με επιτυχία",
                error: "Κάτι πήγε στραβά, δοκιμάστε ξανά ή αργότερα",
            },
            footer: {
                powered_by: "Υποστηρίζεται από",
                terms_and_conditions: "Όροι και Προϋποθέσεις",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Απόδειξη κράτησης',
            details: {
                datetime: 'Κράτηση για',
                number_of_people: 'Αριθμός ανθρώπων',
                placed: 'Τοποθετήθηκε',
                updated: 'Τελευταία ενημέρωση',
                notes: 'Σημειώσεις',
                name: 'Όνομα',
                email: 'E-Mail',
                phone: 'Τηλέφωνο',
                store_address: 'Διεύθυνση καταστήματος',
            },
            status_update: {
                title: 'Κράτηση {{number}} ανανεώθηκε',
                body: 'Η κατάσταση της κράτησής σας έχει ενημερωθεί σε {{status}}',
            },
            email_common: {
                name: 'Όνομα: {{name}}',
                phone: 'Τηλέφωνο: {{number}}',
                number_of_people: 'Αριθμός ατόμων: {{number}}',
                date: 'Ημερομηνία: {{date}}',
                time: 'Ώρα: {{time}}',
                location: 'Τοποθεσία καταστήματος: {{name}}',
                notes: 'Σημειώσεις: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Νέα κράτηση τραπεζιού {{number}} από {{name}}',
                powered_by: 'Υποστηρίζεται από {{name}}',
                overview: 'Νέο αίτημα κράτησης τραπεζιού',
                title: 'Νέα κράτηση για {{name}}',
                subtitle: 'Αριθμός κράτησης {{number}}',
                description_confirmed: 'Η κράτηση επιβεβαιώνεται αυτόματα. Μπορείτε να την ακυρώσετε μέσω του πίνακα ελέγχου διαχειριστή και ο πελάτης σας θα ειδοποιηθεί με email',
                description_unconfirmed: 'Επιβεβαιώστε ή ακυρώστε την κράτηση μέσω του πίνακα ελέγχου διαχειριστή',
                url_pre_text: 'Προβολή και ενημέρωση στο',
            },
            email_new_booking_customer: {
                subject: 'Αίτημα κράτησης τραπεζιού',
                powered_by: 'Υποστηρίζεται από {{name}}',
                overview: 'Νέο αίτημα κράτησης τραπεζιού',
                title: 'Σας ευχαριστούμε για την κράτησή σας',
                subtitle: 'Αριθμός κράτησης {{number}}',
                description: '<b>Θα λάβετε άλλο e-mail όταν η κράτησή σας επιβεβαιωθεί ή απορριφθεί.</b><br>Επικοινωνήστε μαζί μας για να κάνετε οποιαδήποτε αλλαγή στην κράτησή σας. Οι λεπτομέρειες της κράτησής σας έχουν ως εξής:',
                url_pre_text: 'Μπορείτε να δείτε την απόδειξη κράτησης σε πραγματικό χρόνο στη διεύθυνση',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Επιβεβαιώθηκε η κράτηση τραπεζιού',
                subject_unconfirmed: 'Η κράτηση τραπεζιού ακυρώθηκε',
                powered_by: 'Υποστηρίζεται από {{name}}',
                overview: 'Αίτημα κράτησης τραπεζιού',
                title_confirmed: 'Η κράτηση επιβεβαιώθηκε',
                title_unconfirmed: 'Η κράτηση ακυρώθηκε',
                subtitle: 'Αριθμός κράτησης {{number}}',
                description_confirmed: 'Ανυπομονούμε να σας δούμε. Επικοινωνήστε μαζί μας για να ζητήσετε τυχόν αλλαγές στην κράτησή σας',
                description_unconfirmed: 'Λυπούμαστε που σας ενημερώνουμε ότι το αίτημά σας για κράτηση δεν έγινε αποδεκτό. Απολογούμαστε για οποιαδήποτε ταλαιπωρία που προκλήθηκε. Παρακαλούμε επικοινωνήστε μαζί μας εάν έχετε οποιεσδήποτε ερωτήσεις',
                url_pre_text: 'Μπορείτε να δείτε την απόδειξη κράτησης σε πραγματικό χρόνο στη διεύθυνση',
            },
            email_status_update_customer: {
                subject: 'Κράτηση #{{number}} – {{subjectLabel}}',
                body: 'Η κράτησή σας #{{number}} στο {{store}} είναι πλέον {{status}}.',
            },
            errors: {},
            status_warning: 'Ενημερώστε την κατάσταση αυτής της κράτησης στον πίνακα ελέγχου διαχειριστή στη σελίδα κρατήσεων',
        },
    },
    email_delayed_order: {
        subject: 'Παραγγελία #{{number}} – {{subjectLabel}}',
        header: 'Ενημερωμένη ώρα ετοιμασίας',
        title: 'Ενημερωμένη ώρα ετοιμασίας',
        order_number: 'Αριθμός παραγγελίας: {{number}}',
        description: 'Η παραγγελία σας θα είναι έτοιμη στις {{time}}.',
        order_time_updated_to: 'Η ώρα της παραγγελίας σας ενημερώθηκε.',
        powered_by: 'Τροφοδοτείται από {{name}}',
        button_text: 'Παρακολούθηση παραγγελίας',
        subject_label: 'Ενημερωμένη ώρα ετοιμασίας',
        subject_label_delivery: 'Ενημερωμένη ώρα παράδοσης',
        body_ready: 'Η παραγγελία σας θα είναι έτοιμη στις {{time}}.',
        body_delivery: 'Η παραγγελία σας θα παραδοθεί στις {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Εκτ. Χρόνος ετοιμασίας',
            est_driver_pickup_time: 'Εκτ. Ώρα παραλαβής από τον οδηγό ',
            est_delivery_time: 'Εκτ. Ώρα παράδοσης',
            tab_details: 'Λεπτομέριες',
            tab_dishes: 'Πιάτα',
            details: {
                status: 'Κατάσταση',
                placed: 'Ολοκλήρωση ',
                due: 'Οφειλή',
                due_asap: 'Τώρα / Το συντομότερον',
                last_updated: 'Τελευταία ενημέρωση',
                total: 'Σύνολο',
                type: 'Τύπος',
                table: 'Τραπέζι',
                number_of_people: 'Αριθμός ανθρώπων',
                payment_method: 'Μέθοδος πληρωμής',
                payment_status: 'Κατάσταση πληρωμής',
                payment_currency: 'Νόμισμα πληρωμής',
                notes: 'Σημειώσεις',
                name: 'Ονομα',
                email: 'E-Mail',
                phone: 'Τηλέφωνο',
                distance: 'Απόσταση',
                driving_time: 'Ώρα οδήγησης',
                delivery_zone: 'Ζώνη',
                delivery_address: 'Διεύθυνση παράδοσης',
                delivery_provider: 'Πάροχος παράδοσης',
                delivery_tracking: 'Παρακολούθηση παράδοσης',
                delivery_return_tracking: 'Παρακολούθηση επιστροφής',
                delivery_tracking_link: 'Παρακολούθηση παραγγελίας',
                tookan_status: 'Tookan κατάσταση',
                tookan_status_failed_book: 'Αποτυχία καταχώρησης παραγγελίας',
                tookan_status_failed_update: 'Αποτυχία ανανέωσης παραγγελίας',
                tookan_status_success: 'Επιτυχής κράτηση για delivery',
                store_address: 'Διεύθυνση καταστήματος',
            },
            dishes: {
                headings: {
                    quantity: 'Ποσότητα',
                    item: 'Είδος',
                    price: 'Τιμή',
                },
                notes: 'Σημειώσεις',
                remove_ingredients: 'Αφαίρεση συστατικών',
            },
            status_update: {
                title: 'Ανανέωση παραγγελίας {{number}}',
                body: 'Η κατάσταση της παραγγελίας σας έχει ενημερωθεί σε {{status}}',
            },
            wait_time_update: {
                title: 'Ανανέωση παραγγελίας {{number}}',
                body: 'Ο χρόνος λήξης της παραγγελίας σας ενημερώθηκε',
            },
            delivery_update: {
                title: 'Ανανέωση παραγγελίας {{number}}',
                body: 'Η παραγγελία σας έχει επιβεβαιωθεί για παράδοση. Δείτε το σύνδεσμο παρακολούθησης σε πραγματικό χρόνο',
            },
            email_new_order_restaurant: {
                subject: "Νέα παραγγελία ({{number}}) - {{name}}",
                powered_by: "Υποστηρίζεται από {{name}}",
                overview: "Ειδοποίηση νέας παραγγελίας",
                title: "Νέα παραγγελία τοποθετήθηκε από {{name}}",
                subtitle: "Αριθμός παραγγελίας {{number}}",
                description: "Δείτε λεπτομέρειες και ενημερώσεις μέσω του πίνακα ελέγχου διαχειριστή",
                button_text: "Προβολή παραγγελίας",
                track_delivery_button_text: "Παρακολούθηση Delivery",
            },
            email_new_order_customer: {
                subject: "Απόδειξη παραγγελίας ({{number}})",
                powered_by: "Υποστηρίζεται από {{name}}",
                overview: "Ειδοποίηση νέας παραγγελίας",
                title: "Νέα παραγγελία καταχωρήθηκε από {{name}}",
                subtitle: "Αριθμός παραγγελίας {{number}}",
                description: "Δείτε λεπτομέρειες και ενημερώσεις μέσω της διαδικτυακής απόδειξης σε πραγματικό χρόνο",
                button_text: "Προβολή απόδειξης",
                track_delivery_button_text: "Παρακολούθηση Delivery",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) περιλαμβάνεται στην τιμή",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Κόστος Delivery",
            promo: "Έκπτωση: {{name}} ({{value, currency}} + {{percent}}% έχει αφαιρεθεί)",
            promo_percent: "Έκπτωση: {{name}} ({{percent}}%)",
            promo_fixed: "Έκπτωση: {{name}}",
            promo_none: "Έκπτωση: {{name}}",
            cart: "Καλάθι",
            tip: "Φιλοδώρημα",
            total: "Σύνολο",
        },
        status: {
            unconfirmed: "Δεν επιβεβαιώθηκε",
            confirmed: "Επιβεβαιώθηκε",
            ready: "Έτοιμη",
            on_route: "Στον δρόμο",
            complete: "Ολοκληρωμένη",
            cancelled: "Ακυρωμένη",
            seated: "Καθισμένοι",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Μη διαθέσιμο",
                },
            },
            dish: {
                no_stock: "Μη διαθέσιμο",
                not_available: "Μη διαθέσιμο",
            },
        },
    },
};
//# sourceMappingURL=el.js.map